export default {
  getCustomerName: (state) => (id) => {
    var customer = state.items?.find((customer) => customer.customerId == id);
    if (!customer) return "";
    return customer.name;
  },
};
